var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs6":"","sm5":""}},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","label":"Status","persistent-hint":"","return-object":"","single-line":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }